import type { DialogTree } from '@/types';

const config: DialogTree = {
  startDialogId: 'part2_opening0',
  nodes: {
    part2_opening0:{
      id: 'part2_opening0',
      speaker: 'Bunga',
      // text: `Oke, nanti kembali ke sini ya. Kita masuk bersama.`,
      text: `Oke, nanti kembali ke sini ya. Kita masuk bersama.`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/rumah.png',
      nextDialogId : "part2_opening1",
    },
    part2_opening1: {
      id: 'part2_opening1',
      speaker: 'Yan',
      text: `Sepertinya aku harus mencari kado untuk Diana..`,
      isEnd : true
    },
  },
};
export default config;
